import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IWelcomePageRedirectsForm, IWelcomePageRedirectsResponse } from '../types';
import {
  WELCOME_PAGE_REDIRECTS_LIST_API_URL,
  WELCOME_PAGE_REDIRECTS_LIST_QUERY_KEY,
  WELCOME_PAGE_REDIRECTS_PERMISSIONS,
} from '../constants';

export default function useWelcomePageRedirectsQuery(): IContextQueryResult<
  IWelcomePageRedirectsResponse,
  Error,
  IWelcomePageRedirectsForm
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IWelcomePageRedirectsResponse, Error, IWelcomePageRedirectsForm>({
    queryKey: [WELCOME_PAGE_REDIRECTS_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IWelcomePageRedirectsResponse>(
      WELCOME_PAGE_REDIRECTS_LIST_API_URL,
      {
        signal,
        permission: WELCOME_PAGE_REDIRECTS_PERMISSIONS.SHOW,
      },
    ),
    select: (data) => data.welcome_page_redirects,
  });
}
